import React from 'react'
import moment from "moment";
import 'moment/locale/es';
import { Transaction } from "../../models/interfaces";


interface TransactionDetailProps {
  transaction: Transaction;
  showMerchant?: boolean;
}

function TransactionDetail({ transaction, showMerchant = true }: TransactionDetailProps) {
  moment.locale('es');

  const isRefund = String(transaction.transaction_type_desc ?? '').toLowerCase() === "refund";
  const type = getTransactionType(transaction.transaction_type_desc, transaction.status);

  return (
    <tr>
      <td className="fw-medium" style={{ fontFamily: 'monospace' }}>{transaction.external_transaction_reference || '-'}</td>
      <td className="text-muted" style={{ fontFamily: 'monospace' }}>{transaction.auth_code || '-'}</td>
      <td className={`text-end fw-semibold ${isRefund ? 'text-danger' : ''}`} style={{ whiteSpace: 'nowrap' }}>
        {isRefund ? '-' : ''}{getAmount(transaction)}
      </td>
      <td style={{ whiteSpace: 'nowrap' }}>{moment(transaction.date_time).format('DD/MM/YYYY HH:mm')}</td>
      <td style={{ whiteSpace: 'nowrap' }}>
        {transaction.scheme && (
          <span className="badge bg-light text-dark border me-2">{String(transaction.scheme).toUpperCase()}</span>
        )}
        <span className="text-muted" style={{ fontFamily: 'monospace' }}>{getCard(transaction.pan)}</span>
      </td>
      <td>
        {type.label ? <span className={`badge rounded-pill ${type.badgeClass}`}>{type.label}</span> : '-'}
      </td>
      <td>{(transaction.mode == '3DS' ? 'E-commerce' : 'POS')}</td>
      {showMerchant && <td style={{ whiteSpace: 'nowrap' }}>{transaction.merchant?.name ?? '-'}</td>}
      <td style={{ whiteSpace: 'nowrap' }}>{transaction.full_name || '-'}</td>
    </tr>
  );
}


function getAmount(transaction: Transaction): string {
  const amount = Number(transaction.amount ?? 0) / 100;
  return formatMoney(amount) + " " + (transaction.currency_code == 188 ? "CRC" : "USD");
}

function getTransactionType(transactionType: string, status: string): { label: string; badgeClass: string } {
  switch (transactionType) {
    case "PAYMENT":
      return status == "DECLINED"
        ? { label: "Rechazado", badgeClass: 'bg-danger-subtle text-danger-emphasis' }
        : { label: "Autorización", badgeClass: 'bg-success-subtle text-success-emphasis' };
    case "REFUND":
      return { label: "Devolución", badgeClass: 'bg-warning-subtle text-warning-emphasis' };
    case "VOID":
      return { label: "Anulación", badgeClass: 'bg-secondary-subtle text-secondary-emphasis' };
    case "PREAUTH":
      return { label: "Preautorización", badgeClass: 'bg-info-subtle text-info-emphasis' };
    case "COMPLETE":
      return { label: "Autorización", badgeClass: 'bg-success-subtle text-success-emphasis' };
    default:
      return { label: "", badgeClass: '' };
  }
}

function getCard(pan: string) {
  if (pan == null || pan == undefined) return "-";

  const parts = pan.split('*');
  return "•••• " + parts[parts.length - 1];
}

function formatMoney(amount: number) {
  return amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
    style: 'decimal',
  });
};


export default TransactionDetail;
